import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchAuditLogs } from '../../common/api/historyLogsService';
import { RootState } from '../../app/store';
import { LOADING_STATUS } from '../../common/constants';
import {
  InitialPaginationResponse,
  PaginationParameters,
  PaginationResponse,
  PopulatePagination,
} from '../../common/types/pagination.types';

export interface AuditLogsState {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  auditLogItems: any;
  status: LOADING_STATUS.IDLE | LOADING_STATUS.LOADING | LOADING_STATUS.FAILED;
  pagination: PaginationResponse;
}

export interface AuditLogsFilter {
  PageSize: number;
  PageNumber: number;
}

const initialState: AuditLogsState = {
  auditLogItems: [],
  status: LOADING_STATUS.IDLE,
  pagination: InitialPaginationResponse,
};

export const getAuditLogsAsync = createAsyncThunk(
  'auditLogs/getAuditLogs',
  async (auditLogsFilter: PaginationParameters, { rejectWithValue }) => {
    try {
      const response = await fetchAuditLogs(auditLogsFilter);
      return response;
    } catch (error) {
      // Use custom error response
      return rejectWithValue(error.response);
    }
  },
);

const auditLogsSlice = createSlice({
  name: 'auditLogs',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAuditLogsAsync.pending, state => {
        state.status = LOADING_STATUS.LOADING;
      })
      .addCase(getAuditLogsAsync.fulfilled, (state, action) => {
        state.status = LOADING_STATUS.IDLE;
        state.auditLogItems = action.payload.data;
        state.pagination = PopulatePagination(action.payload);
      })
      .addCase(getAuditLogsAsync.rejected, state => {
        state.status = LOADING_STATUS.FAILED;
      });
  },
});

export const selectAuditLogItems = (state: RootState) =>
  state.auditLogs.auditLogItems;
export const selectAuditLogItemsLoadingStatus = (state: RootState) =>
  state.auditLogs.status;
export const selectAuditLogsPagination = (state: RootState) =>
  state.auditLogs.pagination;

export default auditLogsSlice.reducer;
